(function () {
  'use strict';

  var SECTION_SELECTOR = '.tpl--index .nr-reviews-head-section + .shopify-section';
  var ROOT_SELECTOR = '.tpl--index .nr-reviews-head-section + .shopify-section [data-widget="reviews-grid"]';
  var GROUPS = [
    { id: 'all', label: 'All setups' },
    { id: 'nets', label: 'Nets' },
    { id: 'packages', label: 'Packages' },
    { id: 'accessories', label: 'Accessories' },
    { id: 'simulators', label: 'Simulators' }
  ];
  var scheduled = false;
  var observer = null;
  var resizeFrame = null;

  function mediaKey(value) {
    if (!value) return '';

    try {
      return new URL(value, window.location.origin).pathname.split('/').pop() || '';
    } catch (error) {
      return String(value).split('?')[0].split('/').pop() || '';
    }
  }

  function parseGallery(root) {
    try {
      var data = JSON.parse(root.getAttribute('data-tb-modal-json') || '{}');
      return Array.isArray(data.photo_gallery) ? data.photo_gallery : [];
    } catch (error) {
      return [];
    }
  }

  function productGroup(review) {
    var title = String(review && review.product_title || '').toLowerCase();
    var productPath = '';
    try {
      var origin = typeof window !== 'undefined' && window.location ? window.location.origin : 'https://www.thenetreturn.com';
      productPath = new URL(review && review.product_url || '', origin).pathname.replace(/[-_/]+/g, ' ');
    } catch (error) {
      productPath = String(review && review.product_url || '').replace(/[-_/]+/g, ' ');
    }
    var collections = Array.isArray(review && review.collections) ? review.collections : [];
    var metadata = [
      review && (review.product_type || review.productType),
      review && (review.product_tags || review.tags),
      collections.map(function (collection) {
        if (typeof collection === 'string') return collection;
        return collection && [collection.handle, collection.title].filter(Boolean).join(' ');
      }).join(' ')
    ].filter(Boolean).join(' ').toLowerCase();
    var classification = metadata + ' ' + title + ' ' + productPath.toLowerCase();

    if (/package|bundle/.test(classification)) return 'packages';
    if (/simulator|launch|garmin|uneekor|foresight|flight ?scope|full swing|rapsodo|skytrak/.test(classification)) return 'simulators';
    if (/no fly|barrier|guardian|cover|mat|turf|accessor|replacement|target|sandbag|duffle|\bbags?\b|tee\b/.test(classification)) return 'accessories';
    if (title !== 'the net return' && /\bnets?\b|home series|pro series|mini pro/.test(classification)) return 'nets';
    return 'all-only';
  }

  function conciseProductTitle(review) {
    var title = String(review && review.product_title || '').trim();
    if (!title || title === 'The Net Return') return 'Customer setup';

    return title
      .replace(/\bGolf\b/gi, '')
      .replace(/\bSeries\b/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function galleryMap(root) {
    var map = new Map();

    parseGallery(root).forEach(function (review) {
      (review.pictures_urls || []).forEach(function (picture) {
        Object.keys(picture || {}).forEach(function (size) {
          var key = mediaKey(picture[size]);
          if (key) map.set(key, review);
        });
      });
    });

    return map;
  }

  function addCardMeta(card, review) {
    if (card.querySelector('.nr-review-card__meta')) return;

    var title = conciseProductTitle(review);
    var rating = review && review.rating ? String(review.rating) : '';
    var meta = document.createElement('div');
    meta.className = 'nr-review-card__meta';
    meta.setAttribute('aria-hidden', 'true');

    var product = document.createElement('span');
    product.className = 'nr-review-card__product';
    product.textContent = title;
    meta.appendChild(product);

    if (rating) {
      var score = document.createElement('span');
      score.className = 'nr-review-card__rating';
      var template = document.querySelector('[data-nr-review-star-template]');
      var star = template && template.content && template.content.firstElementChild
        ? template.content.firstElementChild.cloneNode(true)
        : null;
      var value = document.createElement('span');
      value.textContent = rating + '.0';
      if (star) score.appendChild(star);
      score.appendChild(value);
      meta.appendChild(score);
    }

    card.appendChild(meta);
  }

  function hydrateCards(root) {
    var map = galleryMap(root);

    root.querySelectorAll('.jdgm-review-card').forEach(function (card) {
      var image = card.querySelector('.jdgm-review-card-media__image');
      var review = map.get(mediaKey(image && image.getAttribute('src')));
      var group = productGroup(review);

      card.dataset.nrReviewGroup = group;
      addCardMeta(card, review);
    });
  }

  function visibleCards(root) {
    return Array.from(root.querySelectorAll('.jdgm-review-card')).filter(function (card) {
      return !card.hidden;
    });
  }

  function updateNav(root) {
    var grid = root.querySelector('.jdgm-grid-body');
    var prev = root.querySelector('[data-nr-review-prev]');
    var next = root.querySelector('[data-nr-review-next]');
    if (!grid || !prev || !next) return;

    var max = Math.max(0, grid.scrollWidth - grid.clientWidth);
    prev.disabled = grid.scrollLeft <= 4;
    next.disabled = grid.scrollLeft >= max - 4;
  }

  function filterCards(root, group, announce) {
    var previousGroup = root.dataset.nrReviewFilter || 'all';
    root.dataset.nrReviewFilter = group;

    root.querySelectorAll('.jdgm-review-card').forEach(function (card) {
      card.hidden = group !== 'all' && card.dataset.nrReviewGroup !== group;
    });

    root.querySelectorAll('[data-nr-review-filter]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.nrReviewFilter === group ? 'true' : 'false');
    });

    var grid = root.querySelector('.jdgm-grid-body');
    if (grid && previousGroup !== group) grid.scrollLeft = 0;

    var count = visibleCards(root).length;
    var status = root.querySelector('.nr-review-rail__status');
    if (status && announce) status.textContent = 'Showing ' + count + ' customer setup' + (count === 1 ? '' : 's') + '.';
    window.requestAnimationFrame(function () { updateNav(root); });
  }

  function availableGroups(root) {
    var counts = {};
    root.querySelectorAll('.jdgm-review-card').forEach(function (card) {
      var group = card.dataset.nrReviewGroup;
      counts[group] = (counts[group] || 0) + 1;
    });

    return GROUPS.filter(function (group) {
      return group.id === 'all' || counts[group.id];
    });
  }

  function buildToolbar(root) {
    if (root.querySelector('.nr-review-rail__toolbar')) return;

    var widget = root.querySelector('.jdgm-reviews-grid-widget');
    var loading = root.querySelector('.jm-loading-overlay');
    if (!widget || !loading) return;

    var toolbar = document.createElement('div');
    toolbar.className = 'nr-review-rail__toolbar';

    var filters = document.createElement('div');
    filters.className = 'nr-review-rail__filters';
    filters.setAttribute('role', 'group');
    filters.setAttribute('aria-label', 'Filter customer setups');

    availableGroups(root).forEach(function (group) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'nr-review-rail__filter';
      button.dataset.nrReviewFilter = group.id;
      button.setAttribute('aria-pressed', group.id === 'all' ? 'true' : 'false');
      button.textContent = group.label;
      button.addEventListener('click', function () {
        filterCards(root, group.id, true);
      });
      filters.appendChild(button);
    });

    var nav = document.createElement('div');
    nav.className = 'nr-review-rail__nav';
    nav.setAttribute('aria-label', 'Customer setup carousel');

    ['Previous', 'Next'].forEach(function (label) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'nr-review-rail__nav-button';
      button.textContent = label;
      button.setAttribute('aria-label', label + ' customer setups');
      if (label === 'Previous') button.dataset.nrReviewPrev = '';
      else button.dataset.nrReviewNext = '';
      button.addEventListener('click', function () {
        var grid = root.querySelector('.jdgm-grid-body');
        var card = visibleCards(root)[0];
        if (!grid || !card) return;
        var distance = card.getBoundingClientRect().width + 12;
        grid.scrollBy({ left: label === 'Previous' ? -distance : distance, behavior: 'smooth' });
      });
      nav.appendChild(button);
    });

    var status = document.createElement('p');
    status.className = 'nr-review-rail__status';
    status.setAttribute('aria-live', 'polite');

    toolbar.appendChild(filters);
    toolbar.appendChild(nav);
    toolbar.appendChild(status);
    widget.insertBefore(toolbar, loading);

    var grid = root.querySelector('.jdgm-grid-body');
    if (grid) {
      grid.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () { updateNav(root); });
      }, { passive: true });
    }
  }

  function enhance(root) {
    if (root.dataset.nrReviewRail === 'ready') return true;
    var grid = root.querySelector('.jdgm-grid-body');
    var cards = grid && grid.querySelectorAll('.jdgm-review-card');
    if (!grid || !cards || !cards.length) return false;

    hydrateCards(root);
    buildToolbar(root);
    root.dataset.nrReviewRail = 'ready';

    var active = root.dataset.nrReviewFilter || 'all';
    if (!root.querySelector('[data-nr-review-filter="' + active + '"]')) active = 'all';
    filterCards(root, active, false);

    var showMore = root.querySelector('.jm-show-more-button span');
    if (showMore && !showMore.dataset.nrReviewLabel) {
      showMore.textContent = 'More setups';
      showMore.dataset.nrReviewLabel = 'ready';
    }
    return true;
  }

  function enhanceAll() {
    scheduled = false;
    var roots = Array.from(document.querySelectorAll(ROOT_SELECTOR));
    var ready = roots.length > 0 && roots.every(enhance);
    if (ready && observer) {
      observer.disconnect();
      observer = null;
    }
    positionChatActivator();
    return ready;
  }

  function positionChatActivator() {
    var host = document.querySelector('shopify-chat');
    var shadow = host && host.shadowRoot;
    if (!shadow || shadow.querySelector('[data-nr-home-chat-position]')) return;

    var style = document.createElement('style');
    style.dataset.nrHomeChatPosition = 'ready';
    style.textContent = [
      '.activator-nudge { left: auto !important; right: 12px !important; transform: none !important; }',
      '.activator { width: 46px !important; min-width: 46px !important; height: 46px !important; padding: 0 !important; justify-content: center !important; border-radius: 50% !important; }',
      '.activator__label { display: none !important; }'
    ].join('');
    shadow.appendChild(style);
  }

  function scheduleEnhance() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(enhanceAll, 80);
  }

  function observeReviews() {
    if (!('MutationObserver' in window) || observer) return;
    var section = document.querySelector(SECTION_SELECTOR);
    if (!section || section.querySelector('[data-nr-review-rail="ready"]')) return;
    observer = new MutationObserver(scheduleEnhance);
    observer.observe(section, { childList: true, subtree: true });
  }

  function scheduleNavUpdate() {
    if (resizeFrame !== null) return;
    resizeFrame = window.requestAnimationFrame(function () {
      resizeFrame = null;
      document.querySelectorAll(ROOT_SELECTOR + '[data-nr-review-rail="ready"]').forEach(updateNav);
    });
  }

  function initialize() {
    enhanceAll();
    observeReviews();
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('shopify-chat').then(function () {
        window.setTimeout(positionChatActivator, 0);
        window.setTimeout(positionChatActivator, 400);
      });
    }
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { productGroup: productGroup };
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.addEventListener('resize', scheduleNavUpdate, { passive: true });
})();
